export const CONVERSATION_ATTACHMENT_LIMIT_MB = 25;
export const CONVERSATION_ATTACHMENT_LIMIT_BYTES =
  CONVERSATION_ATTACHMENT_LIMIT_MB * 1024 * 1024;

export const CONVERSATION_ATTACHMENT_SIZE_ERROR_MESSAGE = `Upload failed. Files can be up to ${CONVERSATION_ATTACHMENT_LIMIT_MB} MB. Compress the file or share a link instead.`;

// Screenshots / screen recordings sent for a capture request may be larger
// than composer attachments: the upload endpoint takes 100 MB per file. The
// composer keeps its own 25 MB limit.
export const CAPTURE_UPLOAD_LIMIT_MB = 100;
export const CAPTURE_UPLOAD_LIMIT_BYTES = CAPTURE_UPLOAD_LIMIT_MB * 1024 * 1024;
export const CONVERSATION_ATTACHMENT_UPLOAD_ERROR_MESSAGE =
  "Upload failed. Please check the file type and try again.";

export const isConversationAttachmentTooLarge = (file?: File | null) => {
  return !!file && file.size > CONVERSATION_ATTACHMENT_LIMIT_BYTES;
};

export const getConversationAttachmentDropzoneErrorMessage = (
  fileRejections?: any[]
) => {
  const hasSizeError = (fileRejections || []).some((fileRejection) => {
    return (fileRejection?.errors || []).some((error: any) => {
      const message =
        `${error?.code || ""} ${error?.message || ""}`.toLowerCase();
      return message.includes("file-too-large") || message.includes("size");
    });
  });

  if (hasSizeError) {
    return CONVERSATION_ATTACHMENT_SIZE_ERROR_MESSAGE;
  }

  return CONVERSATION_ATTACHMENT_UPLOAD_ERROR_MESSAGE;
};
